import React from "react";
import "./styles.css";

const Msg = ({ data, noBottomPadding = false, noTopMargin = false }) => {
	return (
		<div
			className={
				noBottomPadding
					? `msg ${data.type} no-bottom-padding`
					: noTopMargin
					? `msg ${data.type} no-top-margin`
					: `msg ${data.type}`
			}
		>
			{data.type === "error" ? (
				<i className="fa fa-times-circle fa-lg" />
			) : data.type === "success" ? (
				<i className="fa fa-check-circle fa-lg" />
			) : data.type === "notice" ? (
				<i className="fa fa-exclamation-triangle fa-lg" />
			) : (
				<i className="fa fa-circle-o-notch fa-spin fa-lg" />
			)}
			<span>{data.text}</span>
		</div>
	);
};

export default Msg;
